import { CustomerEntityBanner } from './CustomEntityBanner';
import {
    EntityApiDefinitionCard,
    EntityConsumedApisCard,
    EntityConsumingComponentsCard,
    EntityHasApisCard,
    EntityProvidedApisCard,
    EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import {
    EntityAboutCard,
    EntityDependsOnComponentsCard,
    EntityDependsOnResourcesCard,
    EntityHasComponentsCard,
    EntityHasSubcomponentsCard,
    EntityHasSystemsCard,
    EntityLayout,
    EntityLinksCard,
    EntitySwitch,
    EntityOrphanWarning,
    EntityProcessingErrorsPanel,
    isComponentType,
    isKind,
    hasCatalogProcessingErrors,
    isOrphan,
    hasRelationWarnings,
    EntityRelationWarning,
} from '@backstage/plugin-catalog';
import { TabbedLayout } from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { SystemAboutCard } from './SystemAboutCard'
import {
    Direction,
    EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import { Content } from '@backstage/core-components';
import { Box } from '@material-ui/core';
const entityWarningContent = (
    <>
        <EntitySwitch>
            <EntitySwitch.Case if={isOrphan}>
                <Grid item xs={12}>
                    <EntityOrphanWarning />
                </Grid>
            </EntitySwitch.Case>
        </EntitySwitch>

        <EntitySwitch>
            <EntitySwitch.Case if={hasRelationWarnings}>
                <Grid item xs={12}>
                    <EntityRelationWarning />
                </Grid>
            </EntitySwitch.Case>
        </EntitySwitch>

        <EntitySwitch>
            <EntitySwitch.Case if={hasCatalogProcessingErrors}>
                <Grid item xs={12}>
                    <EntityProcessingErrorsPanel />
                </Grid>
            </EntitySwitch.Case>
        </EntitySwitch>
    </>
);

// export const customAPIPage = (
//     <>
//         {/* <CustomerEntityBanner /> */}
//         {/* <EntityLayout> */}
//         <EntityLayout>
//             <EntityLayout.Route path="/" title="Definition">
//                 <Content>

//                     <Grid container spacing={3}>
//                         <Grid item xs={12}>
//                             <EntityApiDefinitionCard />
//                         </Grid>
//                     </Grid>
//                 </Content>
//             </EntityLayout.Route>
//             <EntityLayout.Route path="/overview" title="Overview">
//                 <Content>
//                     <Grid container spacing={3}>
//                         {entityWarningContent}
//                         <Grid item md={12}>
//                             {/* <EntityAboutCard /> */}
//                             <SystemAboutCard />
//                         </Grid>
//                         <Grid item md={12} xs={12}>
//                             <EntityCatalogGraphCard variant="gridItem" height={400} />
//                         </Grid>
//                         <Grid item md={12} xs={12}>
//                             <EntityLinksCard />
//                         </Grid>
//                         <Grid container item md={12}>
//                             <Grid item md={6}>
//                                 <EntityProvidingComponentsCard />
//                             </Grid>
//                             <Grid item md={6}>
//                                 <EntityConsumingComponentsCard />
//                             </Grid>
//                         </Grid>
//                     </Grid>
//                 </Content>
//             </EntityLayout.Route>
//   </EntityLayout>    
//   </>
// );


export const customAPIPage = (
  <Box style={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
    <CustomerEntityBanner />

    {/* Scroll container goes here */}
    <Box style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
      <Content>
        <TabbedLayout>
          <TabbedLayout.Route path="/" title="Definition">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <EntityApiDefinitionCard />
              </Grid>
            </Grid>
          </TabbedLayout.Route>

          <TabbedLayout.Route path="/overview" title="Overview">
            <Grid container spacing={3}>
              {entityWarningContent}
              <Grid item md={12}>
                <SystemAboutCard />
              </Grid>
              <Grid item md={12} xs={12}>
                <EntityCatalogGraphCard variant="gridItem" height={400} />
              </Grid>
              <Grid item md={12} xs={12}>
                <EntityLinksCard />
              </Grid>
              <Grid container item md={12}>
                <Grid item md={6}>
                  <EntityProvidingComponentsCard />
                </Grid>
                <Grid item md={6}>
                  <EntityConsumingComponentsCard />
                </Grid>
              </Grid>
            </Grid>
          </TabbedLayout.Route>
        </TabbedLayout>
      </Content>
    </Box>
  </Box>
);


// export const customAPIPage = (
//   <>
//     {/* <CustomerEntityBanner /> */}
//     {/* <EntityLayout> */}
//   <EntityLayout>
//     <EntityLayout.Route path="/" title="Definition">
//       <Content>

//     <TabbedLayout>
//       <TabbedLayout.Route path="/definition" title="Definition">
//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <EntityApiDefinitionCard />
//           </Grid>
//         </Grid>
//       </TabbedLayout.Route>


//       <TabbedLayout.Route path="/overview" title="Overview">
//         <Grid container spacing={3}>
//           {entityWarningContent}
//           <Grid item md={12}>
//             {/* <EntityAboutCard /> */}
//             <SystemAboutCard />
//           </Grid>
//           <Grid item md={12} xs={12}>
//             <EntityCatalogGraphCard variant="gridItem" height={400} />
//           </Grid>
//           <Grid item md={12} xs={12}>
//             <EntityLinksCard />
//           </Grid>
//           <Grid container item md={12}>
//             <Grid item md={6}>
//               <EntityProvidingComponentsCard />
//             </Grid>
//             <Grid item md={6}>
//               <EntityConsumingComponentsCard />
//             </Grid>
//           </Grid>
//         </Grid>
//       </TabbedLayout.Route>
//     </TabbedLayout>
//       </Content>
//     </EntityLayout.Route>
//   </EntityLayout>
//   </>
// );